import { render, staticRenderFns } from "./fbselectbox.vue?vue&type=template&id=2b7866dd&"
import script from "./fbselectbox.vue?vue&type=script&lang=js&"
export * from "./fbselectbox.vue?vue&type=script&lang=js&"
import style0 from "./fbselectbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports